import React, { useState, useEffect } from "react";
import styles from "./ConfigureAnomaly.module.css";
import {
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Spin,
  Tabs,
  Table,
  Tag,
  Tooltip,
  Modal,
  Select,
} from "antd";
import { anomalyEngine } from "../../../../api";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";

const { Option } = Select;

const TabsKeyMapping = {
  1: {
    label: "Event",
    tableName: "EventDetectionInput",
  },
  2: { label: "Instance", tableName: "InstanceDetectionInput" },
};

const MPList = [
  { label: "All", value: "All" },
  { label: "SV5", value: "SV5" },
  { label: "SJC1", value: "SJC1" },
  { label: "AM2", value: "AM2" },
  { label: "FR4", value: "FR4" },
];

let ROLE = null;
const ALLOWEDROLE = ["research admin"];

const ConfigureAnomaly = (props) => {
  ROLE = props.user.role;
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [trig, setTrig] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [relaodData, setReloadData] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  const onClickAdd = () => {
    console.log(activeTab);
    setOpenModal(true);
    setTrig(!trig);
  };

  const onTabsChange = (activeKey) => {
    setActiveTab(activeKey);
  };

  return (
    <>
      {loading ? (
        <Row justify="center" gutter={24}>
          <Col span={1}>
            <Spin tip="Loading..."></Spin>
          </Col>
        </Row>
      ) : (
        <>
          <Row justify={"center"}>
            <Col span={22}>
              <Card bodyStyle={{ paddingTop: "5px" }}>
                <Tabs
                  size={"small"}
                  onChange={onTabsChange}
                  tabBarExtraContent={
                    <>
                      <Row gutter={16} align="middle">
                        <Col>
                          <Input
                            onChange={(e) => setSearchVal(e.target.value)}
                            prefix={
                              <SearchOutlined className="site-form-item-icon" />
                            }
                            placeholder="Search"
                            allowClear
                            enterButton
                          />
                        </Col>
                        <Col>
                          {ALLOWEDROLE.includes(ROLE) ? (
                            <Tooltip title={"Add Entry"}>
                              <PlusOutlined
                                style={{ cursor: "pointer" }}
                                onClick={onClickAdd}
                              />
                            </Tooltip>
                          ) : null}
                        </Col>
                      </Row>
                    </>
                  }
                >
                  <Tabs.TabPane tab={"Event Detection"} key={1}>
                    <EventDetection
                      relaodData={relaodData}
                      searchVal={searchVal}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab={"Instance Detection"} key={2}>
                    <InstanceDetection
                      relaodData={relaodData}
                      searchVal={searchVal}
                    />
                  </Tabs.TabPane>
                </Tabs>
              </Card>
            </Col>
          </Row>
          {ALLOWEDROLE.includes(ROLE) ? (
            <AddDetectionModal
              activeTab={activeTab}
              openModal={openModal}
              trig={trig}
              relaodData={relaodData}
              setReloadData={setReloadData}
            />
          ) : null}
        </>
      )}
    </>
  );
};

const AddDetectionModal = (props) => {
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [appNames, setAppNames] = useState([]);
  const [appNameSel, setAppNameSel] = useState("");
  const [addData, setAddData] = useState({});
  const [tenantId, setTenantId] = useState("");
  const [addEvDetForm] = Form.useForm();

  const openModal = () => setShowModal(props.openModal);

  const getAddModalData = async () => {
    setLoading(true);
    const result = await anomalyEngine({
      function: "getDetectionInputData",
      reqType: "fetch",
      tableName: TabsKeyMapping[props.activeTab].tableName,
      typeOfData: "ADD",
    });
    if (result.success == 0) {
      let appNameList = Object.keys(result.data.addData).map((i) => {
        return { label: i, value: i };
      });
      setAppNames(appNameList);
      setAddData(result.data.addData);
    }
    setLoading(false);
  };

  const addDetection = async (formData) => {
    const result = await anomalyEngine({
      function: "getDetectionInputData",
      reqType: "insert",
      tableName: TabsKeyMapping[props.activeTab].tableName,
      formData: formData,
    });
    if (result.success == 0) {
      message.error(result.data.msg, 4);
    }
    if (result.success == 1) {
      message.success(result.msg);
      closeModModal();
      props.setReloadData(!props.relaodData);
    }
  };

  useEffect(() => {
    if (props.openModal == true) {
      openModal();
      getAddModalData();
    }
  }, [props.trig]);

  const onAppSelect = (value) => {
    setAppNameSel(value);
  };

  const resetForm = () => {
    addEvDetForm.resetFields(["appname", "activities", "disable"]);
  };

  const onFinishForm = (values) => {
    if (TabsKeyMapping[props.activeTab].label === "Instance") {
      if (values.mp === "All") {
        if (values.tenant_id?.trim() && values.tenant_id?.trim() != "") {
          message.error("Can not select MP as All when Tenant Provided");
          return false;
        }
      } else {
        if (!values.tenant_id?.trim() || values.tenant_id?.trim() === "") {
          message.error("Please fill Tenant ID.");
          return false;
        }
      }
    }

    values.activities = values.activities.toString();
    const prio = addData[values.appname].priority;
    values.priority = prio == "" ? 0 : prio == "P1" ? 1 : 2;
    addDetection(values);
  };

  const onSubmit = () => {
    addEvDetForm.submit();
  };

  const onTenantIdChange = (e) => {
    let value = e.target.value.replace(/[^0-9,]/g, "");
    addEvDetForm.setFieldsValue({ tenant_id: value });
  };

  const closeModModal = () => {
    setShowModal(false);
    resetForm();
    setAddData({});
    setAppNames([]);
  };

  return (
    <>
      <Modal
        title={TabsKeyMapping[props.activeTab].label}
        visible={showModal}
        okText={"Submit"}
        onOk={onSubmit}
        onCancel={closeModModal}
        width={"70%"}
      >
        <>
          {loading ? (
            <div>
              <Spin size="small" />
            </div>
          ) : (
            <Form
              name="addDetForm"
              form={addEvDetForm}
              size={"small"}
              initialValues={{}}
              onFinish={onFinishForm}
            >
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name={"appname"}
                    rules={[{ required: true, message: "App Name Required" }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      placeholder="AppName"
                      options={appNames}
                      onChange={onAppSelect}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name={"activities"}
                    rules={[
                      { required: true, message: "No Activities Selected" },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      mode="multiple"
                      allowClear
                      showSearch
                      placeholder="Activities"
                      options={
                        appNameSel ? addData[appNameSel]?.activities : []
                      }
                    />
                  </Form.Item>
                </Col>
                {TabsKeyMapping[props.activeTab].label === "Instance" ? (
                  <>
                    <Col span={3}>
                      <Form.Item
                        name={"mp"}
                        rules={[
                          { required: true, message: "Please Select MP." },
                        ]}
                      >
                        <Select
                          style={{ width: "100%" }}
                          placeholder={"MP"}
                          options={MPList}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item name={"tenant_id"}>
                        <Input
                          placeholder={"Tenant ID"}
                          onChange={onTenantIdChange}
                        />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
                <Col span={2}>
                  <Form.Item name={"disable"} valuePropName={"checked"}>
                    <Checkbox>Disabled</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </>
      </Modal>
    </>
  );
};

const EventDetection = (props) => {
  const [loading, setLoading] = useState(false);
  const [originalTableData, setOriginalTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selEntry, setSelEntry] = useState(null);
  const [trig, setTrig] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  const eventColumn = [
    {
      title: () => {
        return (
          <>
            App Name{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <Tag color="processing">{tableData.length}</Tag>
            )}
          </>
        );
      },
      dataIndex: "appname",
      key: "appname",
      fixed: "left",
      width: "25%",
    },
    {
      title: "Activities",
      dataIndex: "activities",
      key: "activities",
      fixed: "left",
      width: "50%",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      fixed: "left",
      width: "7%",
      render: (text) => (text == 0 ? "" : "P" + text),
    },
    {
      title: "Disable",
      dataIndex: "disable",
      key: "disable",
      fixed: "left",
      width: "7%",
      render: (text) => (text == 1 ? "Yes" : "No"),
    },
  ];

  if (ALLOWEDROLE.includes(ROLE)) {
    eventColumn.push({
      title: "Change",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: "7%",
      render: (text, record) => (
        <a
          onClick={() => {
            setSelEntry(record);
            setOpenModal(true);
            setTrig(!trig);
          }}
        >
          Change
        </a>
      ),
    });
  }

  useEffect(() => {
    fetchEventDetInput();
  }, []);

  useEffect(() => {
    searchInTable();
  }, [props.searchVal, originalTableData]);

  useEffect(() => {
    fetchEventDetInput();
  }, [props.relaodData]);

  const searchInTable = () => {
    if (props.searchVal) {
      let tabD = originalTableData.filter((i) => {
        for (let val of Object.values(i)) {
          if (
            val
              .toString()
              .toLowerCase()
              .indexOf(props.searchVal.toLowerCase()) >= 0
          ) {
            return true;
          }
        }
      });
      setTableData(tabD);
    } else {
      setTableData(originalTableData);
    }
  };

  const fetchEventDetInput = async () => {
    setLoading(true);
    const result = await anomalyEngine({
      function: "getDetectionInputData",
      reqType: "fetch",
      tableName: "EventDetectionInput",
    });
    setOriginalTableData(result?.data?.tableData);
    setTableData(result?.data?.tableData);
    setLoading(false);
  };

  const refreshData = () => {
    fetchEventDetInput();
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            tableLayout={"fixed"}
            size={"small"}
            bordered
            loading={loading}
            dataSource={tableData}
            columns={eventColumn}
            pagination={false}
          />
        </Col>
      </Row>
      <EditDetection
        activeTab={1}
        selEntry={selEntry}
        openModal={openModal}
        trig={trig}
        refreshData={refreshData}
      />
    </>
  );
};

const EditDetection = (props) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [actOption, setActOption] = useState([]);
  const [okBtnCall, setOkBtnCall] = useState(false);

  const openModal = () => setShowModal(props.openModal);

  const editDataFetch = async (record) => {
    setLoading(true);
    const result = await anomalyEngine({
      function: "getDetectionInputData",
      reqType: "fetch",
      typeOfData: "ACTBYAPPNAME",
      tableName: "EventDetectionInput",
      appname: record.appname,
    });
    setActOption(result.data.activities);
    setLoading(false);
  };

  useEffect(() => {
    if (props.openModal == true) {
      editDataFetch(props.selEntry);
      openModal();
    }
  }, [props.trig]);

  const closeModal = () => {
    setShowModal(false);
    setActOption([]);
  };

  return (
    <>
      <Modal
        title={props?.selEntry?.appname}
        visible={showModal}
        onCancel={closeModal}
        onOk={() => setOkBtnCall(true)}
        okText={"Submit"}
        width={"70%"}
        destroyOnClose
      >
        <>
          {loading ? (
            <Row justify="center" gutter={24}>
              <Col span={1}>
                <Spin tip="Loading..."></Spin>
              </Col>
            </Row>
          ) : (
            <EditForm
              activeTab={props.activeTab}
              selEntry={props.selEntry}
              actOption={actOption}
              okBtn={okBtnCall}
              setOkBtn={setOkBtnCall}
              closeModal={closeModal}
              refreshData={props.refreshData}
            />
          )}
        </>
      </Modal>
    </>
  );
};

const EditForm = (props) => {
  const initValue = {
    activities: props.selEntry.activities.split(","),
    disable: props.selEntry.disable,
  };

  if (TabsKeyMapping[props.activeTab].label == "Instance") {
    initValue.mp = props.selEntry.mp;
    initValue.tenant_id = props.selEntry.tenant_id;
  }

  const [formInitValues, setFormInitValues] = useState(initValue);
  const [editForm] = Form.useForm();

  useEffect(() => {
    if (props.okBtn == true) {
      editForm.submit();
      props.setOkBtn(false);
    }
  }, [props.okBtn]);

  const detectionEditSubmit = async (formData) => {
    const result = await anomalyEngine({
      function: "getDetectionInputData",
      reqType: "update",
      tableName: TabsKeyMapping[props.activeTab].tableName,
      id: props.selEntry.id,
      appname: props.selEntry.appname,
      formData: formData,
    });
    if (result.success == 1) {
      props.closeModal();
      props.refreshData();
      message.success(result.msg);
    } else {
      message.error(result.msg);
    }
  };

  const onTenantIdChange = (e) => {
    let value = e.target.value.replace(/[^0-9,]/g, "");
    editForm.setFieldsValue({ tenant_id: value });
  };

  const onFinishEditForm = (values) => {
    if (TabsKeyMapping[props.activeTab].label === "Instance") {
      if (values.mp === "All") {
        if (values.tenant_id?.trim() && values.tenant_id?.trim() != "") {
          message.error("Can not select MP as All when Tenant Provided");
          return false;
        }
      } else {
        if (!values.tenant_id?.trim() || values.tenant_id?.trim() === "") {
          message.error("Please fill Tenant ID.");
          return false;
        }
      }
    }

    values.activities = values.activities.toString();

    detectionEditSubmit(values);
  };
  return (
    <>
      <Form
        name={"editDetForm"}
        size={"small"}
        form={editForm}
        onFinish={onFinishEditForm}
        initialValues={formInitValues}
      >
        <Row gutter={16}>
          <Col span={14}>
            <Form.Item
              name={"activities"}
              rules={[
                {
                  required: true,
                  message: "Please Select Atleast 1 Activity.",
                },
              ]}
            >
              <Select
                style={{ width: "100%" }}
                mode="multiple"
                allowClear
                showSearch
                placeholder="Activities"
                options={props.actOption}
              />
            </Form.Item>
          </Col>
          {TabsKeyMapping[props.activeTab].label == "Instance" ? (
            <>
              <Col span={3}>
                <Form.Item
                  name={"mp"}
                  rules={[{ required: true, message: "Please Select MP." }]}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder={"MP"}
                    options={MPList}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item name={"tenant_id"}>
                  <Input
                    placeholder={"Tenant ID"}
                    onChange={onTenantIdChange}
                  />
                </Form.Item>
              </Col>
            </>
          ) : null}
          <Col span={2}>
            <Form.Item name={"disable"} valuePropName={"checked"}>
              <Checkbox>Disabled</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

const InstanceDetection = (props) => {
  const [loading, setLoading] = useState(false);
  const [originalTableData, setOriginalTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selEntry, setSelEntry] = useState(null);
  const [trig, setTrig] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  const instanceColumn = [
    {
      title: () => {
        return (
          <>
            App Name{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <Tag color="processing">{tableData.length}</Tag>
            )}
          </>
        );
      },
      dataIndex: "appname",
      key: "appname",
      fixed: "left",
      width: "20%",
    },
    {
      title: "Activities",
      dataIndex: "activities",
      key: "activities",
      fixed: "left",
      width: "45%",
    },
    {
      title: "MP",
      dataIndex: "mp",
      key: "mp",
      fixed: "left",
      width: "5%",
    },
    {
      title: "Tenant Id",
      dataIndex: "tenant_id",
      key: "tenant_id",
      fixed: "left",
      width: "10%",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      fixed: "left",
      width: "7%",
      render: (text) => (text == 0 ? "" : "P" + text),
    },
    {
      title: "Disable",
      dataIndex: "disable",
      key: "disable",
      fixed: "left",
      width: "7%",
      render: (text) => (text == 1 ? "Yes" : "No"),
    },
  ];

  if (ALLOWEDROLE.includes(ROLE)) {
    instanceColumn.push({
      title: "Change",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: "7%",
      render: (text, record) => (
        <a
          onClick={() => {
            setSelEntry(record);
            setOpenModal(true);
            setTrig(!trig);
          }}
        >
          Change
        </a>
      ),
    });
  }

  useEffect(() => {
    fetchInstanceDetInput();
  }, []);

  useEffect(() => {
    fetchInstanceDetInput();
  }, [props.relaodData]);

  useEffect(() => {
    searchInTable();
  }, [props.searchVal, originalTableData]);

  const searchInTable = () => {
    if (props.searchVal) {
      let tabD = originalTableData.filter((i) => {
        for (let val of Object.values(i)) {
          if (
            val
              .toString()
              .toLowerCase()
              .indexOf(props.searchVal.toLowerCase()) >= 0
          ) {
            return true;
          }
        }
      });
      setTableData(tabD);
    } else {
      setTableData(originalTableData);
    }
  };

  const fetchInstanceDetInput = async () => {
    setLoading(true);
    const result = await anomalyEngine({
      function: "getDetectionInputData",
      reqType: "fetch",
      tableName: "InstanceDetectionInput",
    });
    setOriginalTableData(result?.data?.tableData);
    setTableData(result?.data?.tableData);
    setLoading(false);
  };

  const refreshData = () => {
    fetchInstanceDetInput();
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            tableLayout={"fixed"}
            size={"small"}
            bordered
            loading={loading}
            dataSource={tableData}
            columns={instanceColumn}
            pagination={false}
          />
        </Col>
      </Row>
      <EditDetection
        activeTab={2}
        selEntry={selEntry}
        openModal={openModal}
        trig={trig}
        refreshData={refreshData}
      />
    </>
  );
};

export default ConfigureAnomaly;
